import { atom, selector } from 'recoil'
import {
  ConfirmStyleType,
  FooterStyleType,
  InsertStyleType,
  JoinTerms,
  MvmoType,
  PartnerInfo,
  TermsStyleType,
  UiData,
  VerifyStyleType
} from 'src/types/type'

export const LoadingState = atom<boolean>({
  key: 'LoadingState',
  default: false,
})

export const JoinStepState = atom<0 | 1>({
  key: 'JoinStepState',
  default: 0,
})

export const CertNumberSubmitState = atom<boolean>({
  key: 'CertNumberSubmitState',
  default: false,
})
const TelTypeState = atom<number>({
  key: 'TelTypeState',
  default: 0,
})
const TelNumState = atom<string>({
  key: 'TelNumState',
  default: '',
})
const TimeoutState = atom<number>({
  key: 'TimeoutState',
  default: 0,
})
const TransIdState = atom<string>({
  key: 'TransIdState',
  default: '',
})
const authKeyState = atom<string | undefined>({
  key: 'authKeyState',
  default: undefined,
})
const CertCheckState = atom<boolean>({
  key: 'CertCheckState',
  default: false,
})
const MvmoTermsState = atom<MvmoType>({
  key: 'MvmoTermsState',
  default: {
    Terms: '',
    TermsTitle: '',
  },
})
const TermsAgreeState = atom<number[]>({
  key: 'TermsAgreeState',
  default: [0, 0, 0, 0, 0, 0, 0, 0, 0],
})
const MvnoCheckValue = atom<boolean>({
  key: 'MvnoCheckValue',
  default: false,
})
const AllCheckState = atom<boolean>({
  key: 'AllCheckState',
  default: false,
})
const CertNumState = atom<string>({
  key: 'CertNumState',
  default: '',
})
const UserTypeState = atom<string>({
  key: 'UserTypeState',
  default: 'PCWEB',
})
const PartnerState = atom<PartnerInfo>({
  key: 'PartnerState',
  default: {
    PSKey: '',
    PCODE: '',
    PGroup: '',
    PName: '',
    FeeRate: 0,
    FeeType: 0,
    FeeCost: 0,
    RewardAPI: '',
    RewardURI: '',
    DelayRewardMin: 0,
    Image1: '',
    Image2: '',
    JoinURL: '',
    FontSize: '13.5px',
    FontColor: '#da2f31',
    NotiContent:
      '매월 1,650원 부가세포함<br/>본 서비스는 SKT, KT, LG U+ 통신요금에 매월 부과됩니다.',
    ButtonMsgBefore: '스마트피싱보호유료서비스가입',
    ButtonMsgAfter: '스마트피싱보호유료서비스가입',
    UiType: '',
    UiData: '',
    SKTJoin: 'Y',
    KTJoin: 'Y',
    LGUPJoin: 'Y',
    JoinBlockMsg: '',
  },
})
const uiData = atom<UiData>({
  key: 'uiData',
  default: {
    layoutsInsert: {
      mainBg: '#fff',
      certs: {
        type: '',
        borderColor: '#fff',
        backgroundColor: '#fff',
      },
      agency: {
        shape: '',
        actColor: '#fff',
      },
    },
    layoutsConfirm: {
      confirmHover: false,
      submitBtn: {
        borderRadius: '5px',
        fontSize: '13.5px',
        letterSpacing: '-1px',
        backgroundColor: '#1e34de',
        fontColor: '#fff',
        fontWeight: 400,
      },
    },
    layoutsFooter: {
      color: 'black',
      backgroundColor: '#fff',
    },
    layoutsTerms: {
      direction: '',
      shape: '',
      actColor: '#fff',
      borderRadius: 'none',
    },
    layoutsVerify: {
      verifyDir: '',
      cashSpace: '-1.5px',
      verifyBtn: {
        borderRadius: '5px',
        fontSize: '13.5px',
        letterSpacing: '0',
        backgroundColor: '#1e34de',
        fontColor: '#fff',
        fontWeight: 400,
      },
      cancelBtn: {
        borderRadius: 'none',
        fontSize: '13.5px',
        letterSpacing: '0',
        backgroundColor: '#fff',
        fontColor: '#d8d8d8',
        fontWeight: 400,
      },
    },
  },
})

const TermsListState = atom<JoinTerms[]>({
  key: 'TermsListState',
  default: [
    // SKT
    {
      TermsIdx: 0,
      Terms: [],
      TermsOrder: ""
    },
    // KT
    {
      TermsIdx: 0,
      Terms: [],
      TermsOrder: ""
    },
    // LGUP
    {
      TermsIdx: 0,
      Terms: [],
      TermsOrder: ""
    }
  ]
})

const TermsSelector = selector({
  key: 'TermsSelector',
  get: ({ get }) => get(TermsListState)?.[get(TelTypeState)],
})

// 필수약관 동의 여부
export const IsAgreeAllRequiredTermsSelector = selector({
  key: 'IsAgreeAllRequiredTermsSelector',
  get: ({ get }) => get(TermsSelector)?.Terms
    .filter((terms) => terms.Required === 1 && terms.Order !== undefined)
    .every((terms) => get(TermsAgreeState)[terms.Order! - 1] === 1) ?? false,
})

const RecoilStateList = selector({
  key: 'RecoilStateList',
  get: ({ get }) => {
    return {
      TelType: get(TelTypeState),
      PhoneNum: get(TelNumState),
      Timeout: get(TimeoutState),
      TransId: get(TransIdState),
      authKeyValue: get(authKeyState),
      CertCheck: get(CertCheckState),
      termsAgree: get(TermsAgreeState),
      AllTermsAgree: get(AllCheckState),
      CertNum: get(CertNumState),
      TermsList: get(TermsListState),
      TermsData: get(TermsSelector),
      UserType: get(UserTypeState),
      isAgreeAllRequiredTerms: get(IsAgreeAllRequiredTermsSelector),
    }
  },
})

const uiInsertsStyle = selector<InsertStyleType>({
  key: 'uiCertsStyle',
  get: ({ get }) => get(uiData).layoutsInsert,
})
const uiConfirmStyle = selector<ConfirmStyleType>({
  key: 'uiConfirmStyle',
  get: ({ get }) => get(uiData).layoutsConfirm,
})
const uiTermsStyle = selector<TermsStyleType>({
  key: 'uiTermsStyle',
  get: ({ get }) => get(uiData).layoutsTerms,
})
const uiVerifyStyle = selector<VerifyStyleType>({
  key: 'uiVerifyStyle',
  get: ({ get }) => get(uiData).layoutsVerify,
})
const uiFooterStyle = selector<FooterStyleType>({
  key: 'uiFooterStyle',
  get: ({ get }) => get(uiData).layoutsFooter,
})
const termsModalOpen = atom<boolean>({
  key: 'termsModalOpen',
  default: false,
})
export {
  AllCheckState, authKeyState,
  CertCheckState, CertNumState, TermsAgreeState, MvmoTermsState,
  MvnoCheckValue, PartnerState,
  RecoilStateList, TelNumState, TelTypeState, TermsListState, termsModalOpen, TermsSelector, TimeoutState,
  TransIdState, uiConfirmStyle, uiData, uiFooterStyle,
  uiInsertsStyle,
  uiTermsStyle,
  uiVerifyStyle, UserTypeState
}

